/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Elternkontaktfehlgeschlagen1Inputs */

const de__field_elternkontaktfehlgeschlagen1 = /** @type {(inputs: _Field_Elternkontaktfehlgeschlagen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elternkontakt fehlgeschlagen`)
};

/**

* @param {_Field_Elternkontaktfehlgeschlagen1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_elternkontaktfehlgeschlagen1 = /** @type {((inputs?: _Field_Elternkontaktfehlgeschlagen1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Elternkontaktfehlgeschlagen1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_elternkontaktfehlgeschlagen1(inputs)
});
export { _field_elternkontaktfehlgeschlagen1 as "_field_elternkontaktFehlgeschlagen" }